import 'bootstrap/dist/css/bootstrap.css';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { Redirect } from 'react-router-dom';
import { Button, Dimmer, Divider, Form, Grid, Header, Input, Loader, Segment } from 'semantic-ui-react';
import { isMultipleSearchAllowed, hasAccessLevelUpdate, sortTableDates, handleLocalSearchInputStorage } from '../../containers/Utils';
import memberSearch from '../../queries/memberSearch';
import CountrySelector from '../Countries';
import DateOfBirth from '../DateOfBirth';
import { checkIfFullAccess } from '../../containers/Authorization';
import './styles.css';

const { SearchBar } = Search;

class MemberSearch extends Component {
  static propTypes = {
    client: PropTypes.shape({
      query: PropTypes.func,
    }),
    setWarningMessage: PropTypes.func.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
    setEnrollPersonRequest: PropTypes.func.isRequired,
    setMemberRequest: PropTypes.func.isRequired,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.location) {
      return {
        memberInput: {
          id: handleLocalSearchInputStorage('get', 'id', ''),
          birthMonth: handleLocalSearchInputStorage('get', 'birthMonth', ''),
          birthDay: handleLocalSearchInputStorage('get', 'birthDay', ''),
          birthYear: handleLocalSearchInputStorage('get', 'birthYear', ''),
          firstName: handleLocalSearchInputStorage('get', 'firstName', ''),
          lastName: handleLocalSearchInputStorage('get', 'lastName', ''),
          addressLine1: handleLocalSearchInputStorage('get', 'addressLine1', ''),
          zipCode: handleLocalSearchInputStorage('get', 'zipCode', ''),
          country: handleLocalSearchInputStorage('get', 'country', 'US'),
          phoneNumber: handleLocalSearchInputStorage('get', 'phoneNumber', ''),
        },
        member: undefined,
        view: false,
        memberLoading: false,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);

    this.state = {
      memberInput: {
        id: '',
        birthMonth: '',
        birthDay: '',
        birthYear: '',
        firstName: '',
        lastName: '',
        addressLine1: '',
        zipCode: '',
        country: 'US',
        phoneNumber: '',
      },
      view: false,
      memberLoading: false,
      multipleMembers: [],
    };
  }

  onChangeValue = (_, data) => {
    const { memberInput } = this.state;
    memberInput[data.name] = data.value;
    this.setState({
      memberInput,
    });
    if (data.name === 'id') {
      this.handleSectionClear('1');
    } else if (data.name === 'phoneNumber') {
      this.handleSectionClear('2');
    } else if (data.name === 'firstName' ||
      data.name === 'lastName' ||
      data.name === 'addressLine1' ||
      data.name === 'zipCode' ||
      data.name === 'birthMonth' ||
      data.name === 'birthDay' ||
      data.name === 'birthYear' ||
      data.name === 'country') {
      this.handleSectionClear('3');
    }
  }

  onKeyPressExecute = (e) => {
    if (e.key === 'Enter') {
      this.search();
    }
  }

  searchWithId = (cell, row, rowIndex) => {
    this.setState({
      memberLoading: true,
    });
    this.searchMembers({
      query: memberSearch,
      variables: {
        input: {
          id: (row.id !== 'NON-MEMBER' ? row.id : ''),
          firstName: (row.id === 'NON-MEMBER' ? row.firstName : ''),
          lastName: (row.id === 'NON-MEMBER' ? row.lastName : ''),
          addressLine1: (row.id === 'NON-MEMBER' ? row.addressLine1 : ''),
          zipCode: (row.id === 'NON-MEMBER' ? row.zipCode : ''),
          birthMonth: (row.id === 'NON-MEMBER' ? row.birthMonth : ''),
          birthDay: (row.id === 'NON-MEMBER' ? row.birthDay : ''),
          birthYear: (row.id === 'NON-MEMBER' ? row.birthYear : ''),
        },
      },
      fetchPolicy: 'network-only',
    });
  }

  multiAccountCellButton(cell, row, rowIndex) {
    let displayButton = true;
    if (row.id === 'NON-MEMBER') {
      if (hasAccessLevelUpdate(this.props)) {
        displayButton = true;
      } else {
        displayButton = false;
      }
    }
    return (
      <Button
        disabled={!displayButton}
        onClick={() => {
          this.searchWithId(cell, row, rowIndex);
        }}
      >Select
      </Button>
    );
  }

  searchMembers = debounce((queryObj) => {
    const { setWarningMessage, setErrorMessage, setEnrollPersonRequest, setMemberRequest } = this.props;

    this.props.client.query(queryObj)
      .then((response) => {
        if (response.data.members.matchCount === 0) {
          setWarningMessage('No members found');
          this.setState({
            view: false,
            memberLoading: false,
          });
        } else if (response.data.members.matchCount > 1) {
          if (isMultipleSearchAllowed(this.props)) {
            this.populateMultipleResponse(response.data.members.members);
          } else {
            setWarningMessage('More than one member found.  Please refine search.');
          }
          this.setState({
            view: false,
            memberLoading: false,
          });
        } else if (response.data.members.member.id) {
          setMemberRequest({ ...response.data.members.member });
          this.setState({
            view: true,
            memberLoading: false,
          });
        } else if (checkIfFullAccess()) {
          setEnrollPersonRequest({ ...response.data.members.member });
          this.setState({
            enroll: true,
            memberLoading: false,
          });
        } else {
          setWarningMessage('No members found');
          this.setState({
            view: false,
            memberLoading: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          view: false,
          memberLoading: false,
        });
        setErrorMessage(`Failed to Search due to error: ${err.message.replace('GraphQL error: ', '')}`);
      });
  }, 200)

  populateMultipleResponse = (data) => {
    const multipleVals = [];
    data.forEach((arrayItem, idx) => {
      const item = {};
      item.key = idx;
      item.id = (arrayItem.id.indexOf('NON-MEMBER') < 0 ? arrayItem.id : 'NON-MEMBER');
      item.firstName = arrayItem.firstName;
      item.lastName = arrayItem.lastName;
      item.addressLine1 = arrayItem.addressLine1;
      item.zipCode = arrayItem.zipCode;
      item.emailAddress = arrayItem.emailAddress;
      item.birthMonth = arrayItem.birthMonth;
      item.birthDay = arrayItem.birthDay;
      item.birthYear = arrayItem.birthYear;
      item.name = `${arrayItem.firstName} ${arrayItem.middleName} ${arrayItem.lastName}`;
      item.address = `${arrayItem.addressLine1} ${arrayItem.city} ${arrayItem.state} - ${arrayItem.zipCode}`;
      if (arrayItem.birthMonth !== '' && arrayItem.birthDay !== '' && arrayItem.birthYear !== '') {
        item.dob = `${arrayItem.birthMonth}/${arrayItem.birthDay}/${arrayItem.birthYear}`;
      }
      multipleVals.push(item);
    });
    this.setState({
      multipleMembers: multipleVals,
    });
  }

  search = () => {
    const { memberInput } = this.state;
    handleLocalSearchInputStorage('add', memberInput, '');
    this.setState({
      memberLoading: true,
    });

    this.searchMembers({
      query: memberSearch,
      variables: {
        input: {
          id: memberInput.id,
          birthMonth: memberInput.birthMonth,
          birthDay: memberInput.birthDay,
          birthYear: memberInput.birthYear,
          firstName: memberInput.firstName,
          lastName: memberInput.lastName,
          addressLine1: memberInput.addressLine1,
          zipCode: memberInput.zipCode,
          country: memberInput.country,
          phoneNumber: memberInput.phoneNumber,
        },
      },
      fetchPolicy: 'network-only',
    });
  }

  handleSectionClear = (section) => {
    const { memberInput } = this.state;
    this.setState({
      memberInput: {
        id: (section !== '1' ? '' : memberInput.id),
        birthMonth: (section !== '3' ? '' : memberInput.birthMonth),
        birthDay: (section !== '3' ? '' : memberInput.birthDay),
        birthYear: (section !== '3' ? '' : memberInput.birthYear),
        firstName: (section !== '3' ? '' : memberInput.firstName),
        lastName: (section !== '3' ? '' : memberInput.lastName),
        addressLine1: (section !== '3' ? '' : memberInput.addressLine1),
        zipCode: (section !== '3' ? '' : memberInput.zipCode),
        country: (section !== '3' ? 'US' : memberInput.country),
        phoneNumber: (section !== '2' ? '' : memberInput.phoneNumber),
      },
      view: false,
      memberLoading: false,
    });
  }

  handleClear = () => {
    handleLocalSearchInputStorage('remove', '', '');
    this.setState({
      memberInput: {
        id: '',
        birthMonth: '',
        birthDay: '',
        birthYear: '',
        firstName: '',
        lastName: '',
        addressLine1: '',
        zipCode: '',
        country: 'US',
        phoneNumber: '',
      },
      view: false,
      memberLoading: false,
    });
  }

  idFormatter = (cell, row) => {
    if (row.id === 'NON-MEMBER') {
      return (
        <span>
          <strong style={{ color: 'red' }}>{cell}</strong>
        </span>
      );
    }
    return (
      <span>{cell}</span>
    );
  }

  multipleDatacolumns = [
    {
      dataField: 'id',
      text: 'Membership Number',
      sort: true,
      headerAlign: 'center',
      headerStyle: { backgroundColor: '#c8e6c9', width: '150px' },
      align: 'center',
      style: { verticalAlign: 'middle' },
      formatter: this.idFormatter,
    },
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
      headerAlign: 'center',
      headerStyle: { backgroundColor: '#c8e6c9' },
      style: { verticalAlign: 'middle' },
    },
    {
      dataField: 'address',
      text: 'Address',
      sort: true,
      headerAlign: 'center',
      headerStyle: { backgroundColor: '#c8e6c9' },
      style: { verticalAlign: 'middle' },
    },
    {
      dataField: 'emailAddress',
      text: 'Email',
      sort: true,
      headerAlign: 'center',
      headerStyle: { backgroundColor: '#c8e6c9' },
      style: { verticalAlign: 'middle' },
    },
    {
      dataField: 'dob',
      text: 'Date of Birth',
      sort: true,
      headerAlign: 'center',
      headerStyle: { backgroundColor: '#c8e6c9', width: '120px' },
      align: 'center',
      style: { verticalAlign: 'middle' },
      sortFunc: (a, b, order) => sortTableDates(a, b, order),
    },
    {
      dataField: 'button',
      text: '',
      headerAlign: 'center',
      headerStyle: { backgroundColor: '#c8e6c9', width: '100px' },
      align: 'center',
      style: { verticalAlign: 'middle' },
      formatter: this.multiAccountCellButton.bind(this),
    },
  ];

  multiDataOptions = {
    paginationSize: 4,
    pageStartIndex: 1,
    firstPageText: '<<',
    prePageText: '<',
    nextPageText: '>',
    lastPageText: '>>',
    showTotal: true,
    disablePageTitle: true,
    sizePerPageList: [
      { text: '10', value: 10 },
      { text: '20', value: 20 },
    ],
  };

  handleCancel = () => {
    this.setState({ cancel: true });
  };

  render() {
    const { memberInput, view, memberLoading, enroll, cancel } = this.state;

    if (view) {
      return <Redirect to="/view" />;
    }

    if (enroll) {
      return <Redirect to="/enroll" />;
    }

    if (cancel) {
      return <Redirect to="/search" />;
    }

    return (
      <Dimmer.Dimmable as="div">
        {
          memberLoading &&
          <Dimmer active={memberLoading}>
            <Loader inverted>Searching Members...</Loader>
          </Dimmer>
        }
        <div styleName="search-container">
          <div>
            {
              this.state.multipleMembers.length === 0 ?
                <Grid>
                  <Grid.Column width={8}>
                    <Header as="h2" dividing styleName="search-header">
                      Search for a Member
                    </Header>
                    <Form size="small">
                      <Form.Field
                        control={Input}
                        label="Membership Number"
                        value={memberInput.id}
                        onChange={this.onChangeValue}
                        onKeyPress={this.onKeyPressExecute}
                        name="id"
                        autoComplete="disabled"
                      />
                      <Divider horizontal>Or</Divider>
                      <Form.Field
                        control={Input}
                        label="Phone Number"
                        value={memberInput.phoneNumber}
                        onChange={this.onChangeValue}
                        onKeyPress={this.onKeyPressExecute}
                        name="phoneNumber"
                        width="5"
                      />
                      <Divider horizontal>Or</Divider>
                      <DateOfBirth
                        member={memberInput}
                        fieldChangeHandler={this.onChangeValue}
                        memberLevel="primary"
                      />
                      <Form.Field
                        control={Input}
                        label="First Name"
                        value={memberInput.firstName}
                        onChange={this.onChangeValue}
                        onKeyPress={this.onKeyPressExecute}
                        name="firstName"
                        autoComplete="disabled"
                      />
                      <Form.Field
                        control={Input}
                        label="Last Name"
                        value={memberInput.lastName}
                        onChange={this.onChangeValue}
                        onKeyPress={this.onKeyPressExecute}
                        name="lastName"
                        autoComplete="disabled"
                      />
                      <Form.Field
                        control={Input}
                        label="Address (Line 1)"
                        value={memberInput.addressLine1}
                        onChange={this.onChangeValue}
                        onKeyPress={this.onKeyPressExecute}
                        name="addressLine1"
                        autoComplete="disabled"
                      />
                      <Form.Field
                        control={Input}
                        label="Zip/Postal Code"
                        value={memberInput.zipCode}
                        onChange={this.onChangeValue}
                        onKeyPress={this.onKeyPressExecute}
                        name="zipCode"
                        width="5"
                        autoComplete="disabled"
                      />
                      <CountrySelector
                        member={memberInput}
                        fieldChangeHandler={this.onChangeValue}
                      />
                      <Button styleName="search-button" type="button" onClick={this.search}>Search</Button>
                      <Button styleName="search-button" type="button" onClick={this.handleClear}>Clear</Button>
                    </Form>
                  </Grid.Column>
                  <Grid.Column width={7}>
                    <Segment styleName="search-help-segment">
                      <b><u>Valid Search Combinations:</u></b>
                      <ul styleName="search-info-combo">
                        <li>Membership Number</li>
                        <li>Phone Number</li>
                        <li>First Name, Last Name, Address Line 1  (optional), Zip/Postal Code, Date of Birth (optional)</li>
                        <li>Last Name, Zip/Postal Code, Date of Birth (optional)</li>
                      </ul>
                    </Segment>
                  </Grid.Column>
                </Grid>
                : null
            }
          </div>
        </div>

        <div styleName="search-multiple-container">
          <div>
            {
              this.state.multipleMembers.length > 0 ?
                <Grid>
                  <Grid.Column>
                    <Header as="h2" dividing styleName="search-header">
                      Multiple Matches found
                    </Header>
                    <Form size="small">
                      <ToolkitProvider
                        keyField="id"
                        data={this.state.multipleMembers}
                        columns={this.multipleDatacolumns}
                        search
                      >
                        {
                          props => (
                            <div>
                              <SearchBar
                                placeholder="Search this list..."
                                {...props.searchProps}
                              />
                              <BootstrapTable
                                {...props.baseProps}
                                bootstrap4
                                striped
                                hover
                                condensed
                                keyField="key"
                                data={this.state.multipleMembers}
                                columns={this.multipleDatacolumns}
                                defaultSorted={[{ dataField: 'name', order: 'asc' }]}
                                pagination={paginationFactory(this.multiDataOptions)}
                              />
                            </div>
                          )
                        }
                      </ToolkitProvider>
                      <Button
                        id="cancelEnrollButton2"
                        type="button"
                        styleName="cancel-button"
                        content="Cancel"
                        onClick={this.handleCancel}
                      />
                    </Form>
                  </Grid.Column>
                </Grid>
                : null
            }
          </div>
        </div>
      </Dimmer.Dimmable>
    );
  }
}

export default MemberSearch;



// WEBPACK FOOTER //
// ./src/app/components/Search/index.js